const list = {
  // =================================================================================================================
  components() {
    return [
      {
        'component': 'search-start-end',
        "label": '작성일',
        "value": 'date',
        "query": {'ss': 'startDate', 'ee': 'endDate'},
        "options": {
          default: {sd: '', ed: ''},
        }
      },
      {
        'component': 'search-column-keyword',
        "label": '검색조건',
        "value": 'column',
        "query": {'ck_t': 'head', 'ck_k': 'keyword'},
        "options": {hiddenList: ['예산', '당월 사용금액', '누계', '작성일']}
      },
    ]
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    //  검색일
    if (search.date) {
      conditions.push({key: 'created_at', operator: '>=', value: search.date.startDate})
      conditions.push({key: 'created_at', operator: '<', value: search.date.endDate ? new Date(search.date.endDate).addDays(1).format("yyyy-MM-dd") : ''})
    }

    //  검색조건
    const heads = list.getHead().map(e => { return {[e.name] : e.key} });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({key: types[search.column.head], operator: 'LIKE', value: `%${search.column.keyword}%`})
    }
    return conditions;
  },


  // =================================================================================================================
  getHead: () => {
    return [
      {
        "name": "회사명",
        "key": "body.stdInfo.field_name"
      },
      {
        "name": "예산",
        "key": "body.total.value2"
      },
      {
        "name": "당월 사용금액",
        "key": "body.total.value3"
      },
      {
        "name": "누계",
        "key": "body.total.value4"
      },
      {
        "name": "작성일",
        "key": "created_at"
      }
    ]
  },
  getCol: (index, value, func) => {
    /**
     * str 값에 쉼표(,) 제거 후 숫자로 변환하여 3자리마다 쉼표(,) 추가하여 반환
     * @param str
     * @returns {string}
     */
    function convertNumber(str) {
      return new Intl.NumberFormat().format(Number(`${str}`.replace(/,/g, '')));
    }

    try {
      switch (index) {
      case 0: return func.getContent(value).stdInfo.field_name // 회사명
      case 1: return convertNumber(func.getContent(value).total.value1) // 예산
      case 2: return convertNumber(func.getContent(value).total.value2) // 당월 사용금액
      case 3: return convertNumber(func.getContent(value).total.value3) // 누계
      case 4: return func.getCreatedDate(value.created_at) // 작성일 // 작성일
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
  getDefaultSort: () => {
    return [{target: '$header.full', order: 'desc'}];
  },
}
export default list;
